module.exports = __webpack_public_path__ + "img/building.b22c5de7.png";